import * as types from "./constants";

export function setActiveTab(item) {
    return {
        type: types.SET_ACTIVE_TAB,
        item,
    }
}